import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const variantDatabaseFormValidationSchema = () => {
  const fields: any = {
    database_id: Yup.number().required(requiredMessage).nullable(),
    classification: Yup.string().trim().required(requiredMessage).nullable(),
    evidence: Yup.string().trim().nullable(),
    comment: Yup.string().trim().nullable(),
  };

  return Yup.object().shape(fields);
};

export const variantDataBaseUpdateFormValidationSchema = Yup.object().shape({
  classification: Yup.string().required('Classification is required'),
  evidence: Yup.string().nullable(),
  comment: Yup.string().nullable(),
});
